import { X, CheckCircle, AlertCircle, Info } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { SPRING_DATA } from '../../lib/motion';
import { useToastStore, type ToastType } from '../../stores/toastStore';
import { cn } from '../../lib/cn';

const TOAST_ICONS: Record<ToastType, typeof CheckCircle> = {
  success: CheckCircle,
  error: AlertCircle,
  info: Info,
};

const TOAST_COLORS: Record<ToastType, string> = {
  success: 'border-success/30 bg-success/10',
  error: 'border-danger/30 bg-danger/10',
  info: 'border-info/30 bg-info/10',
};

const TOAST_ICON_COLORS: Record<ToastType, string> = {
  success: 'text-success',
  error: 'text-danger',
  info: 'text-info',
};

export function ToastContainer() {
  const { toasts, removeToast } = useToastStore();

  return (
    <div className="fixed bottom-4 right-4 z-[100] flex flex-col gap-2 max-w-sm">
      <AnimatePresence initial={false}>
        {toasts.map((t) => {
          const Icon = TOAST_ICONS[t.type];
          return (
            <motion.div
              key={t.id}
              initial={{ opacity: 0, x: 50, scale: 0.95 }}
              animate={{ opacity: 1, x: 0, scale: 1 }}
              exit={{ opacity: 0, x: 50, scale: 0.95 }}
              transition={SPRING_DATA}
              className={cn(
                'flex items-start gap-3 border rounded-xl p-4 backdrop-blur-lg',
                TOAST_COLORS[t.type],
              )}
            >
              <Icon className={cn('w-5 h-5 mt-0.5 shrink-0', TOAST_ICON_COLORS[t.type])} />
              <p className="text-sm text-text flex-1">{t.message}</p>
              <button
                onClick={() => removeToast(t.id)}
                className="text-muted hover:text-text transition-colors shrink-0"
              >
                <X className="w-4 h-4" />
              </button>
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
}
